/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ShapeComparisonMatchList = {
    type: 'array',
    contains: {
        type: 'ShapeComparisonMatch',
    },
} as const;
